import { render, staticRenderFns } from "./douyin-store.vue?vue&type=template&id=c2d0b59e&scoped=true"
import script from "./douyin-store.vue?vue&type=script&lang=js"
export * from "./douyin-store.vue?vue&type=script&lang=js"
import style0 from "./douyin-store.vue?vue&type=style&index=0&id=c2d0b59e&prod&lang=less&scoped=true"
import style1 from "./douyin-store.vue?vue&type=style&index=1&id=c2d0b59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d0b59e",
  null
  
)

export default component.exports